<template>
  <div class="golive">
    <div class="golive-main">
      <div class="golive-one">
        <div class="golive-code">course_id</div>
        <el-input class="golive-input" disabled v-model="obj.course_id"></el-input>
        <div class="golive-bi">必填</div>
        <div class="golive-desc">直播ID</div>
      </div>
      <div class="golive-one">
        <div class="golive-code">enterprise_id</div>
        <el-input class="golive-input" disabled v-model="obj.enterprise_id"></el-input>
        <div class="golive-bi">必填</div>
        <div class="golive-desc">企业id</div>
      </div>
      <div class="golive-one">
        <div class="golive-code">liveType</div>
        <el-input class="golive-input" disabled v-model="obj.liveType"></el-input>
        <div class="golive-bi">必填</div>
        <div class="golive-desc"> 直播类型，取值 live 表示是直播，取值recorded表示是录播 </div>
      </div>
      <div class="golive-one" style="margin-bottom: 5px">
        <div class="golive-code">auth_token</div>
        <el-input class="golive-input" disabled v-model="obj.auth_token"></el-input>
        <div class="golive-bi">必填</div>
        <div class="golive-desc">
          <span class="red">当前日期+streamvideo+enterprise_id</span>
          做md5处理，如当前日期2022年4月19日，企业id为588，则md5(20220419streamvideo588)=3e30f9e681195a6c76cec48709a8f34d,可以做网站
          <a href="http://www.ip33.com/md5.html" target="_blank">http://www.ip33.com/md5.html</a>
          做验证
        </div>
      </div>
      <div class="golive-one">
        <div class="golive-code" style="width: 150px">auth_token代码片段</div>
        <div class="token_code">
          <div style="margin: 10px 0">nowData: <span class="red">{{time}}</span></div>
          <div>streamvideo: <span class="red">streamvideo </span></div>
          <div style="margin: 10px 0">this.obj.user_id: <span class="red">{{obj.enterprise_id}}</span></div>
          <div style="margin: 10px 0">
              this.obj.auth_token = this.$md5(<span class="red">nowData</span>+<span class="red">streamvideo</span>+<span class="red">this.obj.enterprise_id</span>  );
            </div>
            <span class="red">注意:</span>  this.$md5  这个是 vue js-md5 插件
        </div>
      </div>
      <div class="golive-one">
        <div class="golive-code">user_id</div>
        <el-input class="golive-input" disabled v-model="obj.user_id"></el-input>
        <div class="golive-bi">必填</div>
        <div class="golive-desc">
          用户id (对接方），这个人必须是管理员、子账号、或者讲师（主播）账号才可以。如果不是讲师（主播）身份，可以调用
          接口 setTeacher 设置当前人为讲师（主播），否则会报无权限
        </div>
      </div>
      <div class="golive-one" style="margin-bottom: 5px">
        <div class="golive-code">user_token</div>
        <el-input class="golive-input" disabled v-model="obj.user_token"></el-input>
        <div class="golive-bi">必填</div>
        <div class="golive-desc">
          <span class="red">当前日期+registuser+用户ID(对接方)</span>做md5处理
        </div>
      </div>
      <div class="golive-one">
        <div class="golive-code" style="width: 150px">user_token代码片段</div>
        <div class="token_code">
          <div style="margin: 10px 0">nowData: <span class="red">{{time}}</span></div>
          <div>registuser: <span class="red">registuser </span></div>
          <div style="margin: 10px 0">this.obj.user_id: <span class="red">{{obj.user_id}}</span></div>
          <div style="margin: 10px 0">
              this.obj.user_token = this.$md5(<span class="red">nowData</span>+<span class="red">registuser</span>+<span class="red">this.obj.user_id</span>  );
            </div>
            <span class="red">注意:</span>  this.$md5  这个是 vue js-md5 插件
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button @click="cancelhandle">取 消</el-button>
      <el-button type="primary" @click="saveHandle">确 定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    liveItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    baseUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      obj: {
        course_id: "",      // 直播ID
        liveType: "",       // 直播类型
        enterprise_id: "",  // 企业id
        user_id: "",     // 用户id,对接方的id
        auth_token: "",  // 授权token
        user_token: "",  // 用户token
      },
      time:'',   // 时间
    };
  },

  methods: {
    // 获取直播信息
    getData() {
      let nowData = "";
      let date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      nowData = y +""+ m +""+ d;
      this.time = nowData    // 获取当前年月日

      this.obj.course_id = this.liveItem.id;
      this.obj.liveType = 'live';
      this.obj.enterprise_id = this.liveItem.enterprise_id;
      this.obj.user_id = this.liveItem.user_id;
      this.obj.auth_token = this.$md5(nowData + "streamvideo" + this.liveItem.enterprise_id);
      this.obj.user_token = this.$md5(nowData + "registuser" + this.liveItem.user_id);
    },
    cancelhandle() {
      this.$emit("closeDiag");
    },
    saveHandle() {
      // 后端重定向跳转对应的直播页面
      let url = `${this.baseUrl}/v1/base/back/stream_away/?course_id=${this.obj.course_id}&enterprise_id=${this.obj.enterprise_id}&liveType=${this.obj.liveType}&auth_token=${this.obj.auth_token}&user_id=${this.obj.user_id}&user_token=${this.obj.user_token}`

      window.open(url, "_blank");   // 打开新的窗口

    }
  }
};
</script>
<style lang="less" scoped>
  /deep/ .el-input {
  width:300px !important;
}
.token_code{
  // width: 500px;
  border:1px solid #dedede;
  padding: 10px;
}
.golive {
  .golive-main {
    height: 400px;
    overflow: auto;
    .golive-one {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      .golive-code {
        width: 100px;
      }
      .golive-input {
        width: 300px;
      }
      .golive-bi {
        width: 50px;
        padding-left: 10px;
      }
      .golive-desc {
        flex: 1;
        padding-left: 10px;
      }
    }
  }
  .dialog-footer {
    margin-top: 20px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/liveList/liveSet/goLive.vue